import { ShipmentService } from "src/services/shipments";
import { useFileDownload } from "../useFileDownload";

export const useShipmentFileDownload = (shipmentService: ShipmentService) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: fileLoadError,
    retry: retryDownload,
    reset: resetDownload
  } = useFileDownload<File[]>();

  // Shipments with both animal and non-animal pallets carry two invoices, so we
  // ask for File[] and let useFileDownload zip them when there's more than one.
  const downloadFile = (shipmentId: string) => {
    download({
      getFileData: () => shipmentService.getCommercialInvoices(shipmentId),
      zipName: `commercial-invoices-${shipmentId}.zip`
    });
  };

  return {
    downloadFile,
    isFileDownloading,
    fileLoadError,
    retryDownload,
    resetDownload
  };
};
